<template>
  <span v-if="side === 'origin'" class="entry-label" :key="isSelected" :class="{ selected: isSelected }">
    {{ `(${numberInCable}) ${name}` }}
  </span>
  <span v-else class="entry-label" :class="{ selected: isSelected }">
    {{ `${name} (${numberInCable})` }}
  </span>
</template>

<script>
export default {
  name: "ConnectionPointName",

  props: {
    name: String,
    isSelected: Boolean,
    side: {
      type: String
    },
    numberInCable: {
      type: Number
    }
  }
};
</script>

<style scoped>
.entry-label {
  padding: 0 5px;
  white-space: nowrap;
}

.entry-label.selected {
  font-weight: 900;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/ConnectionPointName.vue